// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"472":"533e46b517f316348349","754":"49f4760cee8af7b7a751"}[chunkId] + ".css";
};